import { FC, useEffect, useState } from 'react'
import styled from 'styled-components'
import { constants, Typography } from '@epidemicsound/design-system'
import { useContentfulPreview, useLoading } from 'hooks/hooks'
import { getEntries, Session } from '../../api/contentful'
import { Spinner } from '@epidemicsound/design-system'
import parse from 'html-react-parser'

const { Title } = Typography

const AUPContainer = styled.section`
    background-color: ${constants.COLORS.BLACK};
`

interface AcceptableUsePolicyPageProps {
    isPreview?: boolean
}

export const AcceptableUsePolicyPage: FC<AcceptableUsePolicyPageProps> = ({
    isPreview = false,
}) => {
    const { setPreview } = useContentfulPreview()
    const { isLoading, setLoading } = useLoading()
    const [section, setSection] = useState<Session>()

    useEffect(() => {
        setPreview(isPreview)
        setLoading(true)

        getEntries('landing-page', isPreview)
            .then((page) => {
                setSection(page.sessions[3])
            })
            .finally(() => setLoading(false))
    }, [isPreview])

    const richQuote = section?.richQuote

    return (
        <AUPContainer>
            {(isLoading === false && (
                <>
                    <Title>{section?.title}</Title>
                    {richQuote ? (
                        <p>{parse(richQuote)}</p>
                    ) : (
                        <p>Something went wrong, no data to find.</p>
                    )}
                </>
            )) || <Spinner size={32} />}
        </AUPContainer>
    )
}
